import { Question, QuestionStatus } from "../interfaces/Question"
import { TranslationKey } from "../translations"

const questions: Question[] = [
    {
        id: 1,
        key: 'MainOccupation',
        status: QuestionStatus.NotAnswered,
        heading: TranslationKey.questionWhatIsYourMainOccupation,
        question: TranslationKey.questionWhatIsYourMainOccupation,
        hideQuestionTitle: true,
        category: 'work',
        possibleAnswers: [
            {
                title: TranslationKey.answerIWorkInSweden,
                value: 'iWorkInSweden'
            },
            {
                title: TranslationKey.answerIWorkAbroad,
                value: 'iWorkAbroad',
                followQuestion: 2,
            },
            {
                title: TranslationKey.answerIAmSelfEmployeed,
                value: 'iAmSelfEmployeed'
            },
            {
                title: TranslationKey.answerIDoNotCurrentlyWork,
                value: 'iDoNotCurrentlyWork',
                followQuestion: 3
            },
            {
                title: TranslationKey.answerIAmAPostDoc,
                value: 'iAmAPhDorPostDoc',
                followQuestion: 7,
                ignoreQuestion: 4
            },
        ],
        type: 'radio',
        givenAnswer: null,
    },
    {
        id: 2,
        key: 'WorkingInCountry',
        status: QuestionStatus.Skip,
        heading: TranslationKey.headingCountry,
        question: TranslationKey.questionInWhatCountryDoYouWork,
        possibleAnswers: null,
        type: 'text-input',
        givenAnswer: null,
        category: 'work'
    },
    {
        id: 3,
        key: 'HaveWorkedBefore',
        status: QuestionStatus.Skip,
        heading: TranslationKey.headingWork,
        description: TranslationKey.questionHaveYouWorkedBeforeDescription,
        question: TranslationKey.questionHaveYouWorkedBefore,
        category: 'work',
        possibleAnswers: [
            {
                title: TranslationKey.answerYesInSweden,
                value: 'yesInSweden'
            },
            {
                title: TranslationKey.answerYesButAbroad,
                value: 'yesButAbroad',
                complementaryFields: [
                    {
                        name: 'country',
                        label: TranslationKey.answerCountry
                    }
                ]
            },
            {
                title: TranslationKey.answerNoNever,
                value: 'noNever'
            }
        ],
        type: 'radio',
        givenAnswer: null
    },
    {
        id: 4,
        key: 'HigherEducationCredit',
        status: QuestionStatus.NotAnswered,
        heading: TranslationKey.headingEducation,
        question: TranslationKey.questionHowManyEducationPoints,
        category: 'education',
        possibleAnswers: [
            {
                title: TranslationKey.answerYes,
                value: 'yes'
            },
            {
                title: TranslationKey.answerNo,
                value: 'no',
                followQuestion: 5
            },
            {
                title: TranslationKey.answerIStudyWithGoal180,
                value: 'goalWith180'
            }
        ],
        type: 'radio',
        givenAnswer: null
    },
    {
        id: 5,
        key: 'InternationalEducation',
        status: QuestionStatus.Skip,
        heading: TranslationKey.headingEducation,
        question: TranslationKey.questionDoYouHaveAInternationalEducation,
        category: 'education',
        possibleAnswers: [
            {
                title: TranslationKey.answerYes,
                value: 'yes'
            },
            {
                title: TranslationKey.answerNo,
                value: 'no',
                followQuestion: 6
            },
            {
                title: TranslationKey.answerUncertainUniCountryDegree,
                value: 'uncertain',
                complementaryFields: [
                    {
                        name: 'university',
                        label: TranslationKey.answerUniversity,
                    },
                    {
                        name: 'country',
                        label: TranslationKey.answerCountry,
                    },
                    {
                        name: 'degree',
                        label: TranslationKey.answerDegree,
                    }
                ],
                followQuestion: 6
            }
        ],
        type: 'radio',
        givenAnswer: null
    },
    {
        id: 6,
        key: 'WorkAs',
        status: QuestionStatus.Skip,
        heading: TranslationKey.headingWork,
        question: TranslationKey.questionDoYouWorkAs,
        category: 'work',
        possibleAnswers: [
            {
                title: TranslationKey.answerMarineOfficer,
                value: 'marineOfficer'
            },
            {
                title: TranslationKey.answerMilitaryPersonnel,
                value: 'militaryPersonnel'
            },
            {
                title: TranslationKey.answerUDStaff,
                value: 'UDStaff'
            },
            {
                title: TranslationKey.answerFlightEngineer,
                value: 'flightEngineer'
            },
            {
                title: TranslationKey.answerPrincipal,
                value: 'principal'
            },
            {
                title: TranslationKey.answerQualifiedTeacher,
                value: 'qualifiedTeacher'
            },
            {
                title: TranslationKey.answerOther,
                value: 'other',
                tooltipTranslationKey: TranslationKey.answerOtherDescriptive,
                complementaryFields: [
                    {
                        name: 'other',
                        label: TranslationKey.answerOther,
                    },
                ]
            },
        ],
        type: 'radio',
        givenAnswer: null
    },
    {
        id: 7,
        key: 'Paid',
        status: QuestionStatus.Skip,
        heading: TranslationKey.headingIncome,
        question: TranslationKey.questionHowDoYouGetPaid,
        category: 'work',
        possibleAnswers: [
            {
                title: TranslationKey.answerIGetASalary,
                value: 'onlySalary'
            },
            {
                title: TranslationKey.answerIGetASalaryAndScholarship,
                value: 'salaryAndScholarship'
            },
            {
                title: TranslationKey.answerIGetOnlyAScholarship,
                value: 'onlyScholarship',
                followQuestion: 3
            },
        ],
        type: 'radio',
        givenAnswer: null
    }
]

export default questions